export default __webpack_public_path__ + "static/media/12-traumnovelle.0e663a63.jpg";